















import { Component, Prop, Vue } from "vue-property-decorator";
import { Plant, Image, PlantImage } from "@/types";

@Component
export default class PlantCard extends Vue {
  @Prop() private plant!: Plant;
  @Prop() private images!: PlantImage;

  get locations() {
    return this.$store.getters.findPlantInGarden(this.plant.number);
  }

  get image(): Image | null {
    if (this.images) {
      if (this.images.gardenImages.length > 0) {
        return this.images.gardenImages[0];
      } else if (this.images.googleImages.length > 0) {
        return this.images.googleImages[0];
      }
    }
    return {
      image:
        "https://dummyimage.com/300x300/d8e6cf/ffffff.png&text=geen+afbeelding",
    };
  }
}
